import { Stack, Typography } from "@mui/material";
import ScoutIcon from "components/ScoutIcon";

import type { ScoutAttachment } from "../scoutSubmitAttachments";

import { ScoutChatDropzone } from "./ScoutChatDropzone";
import { ScoutInput, type ScoutSubmitHandler } from "./ScoutInput";
import { SuggestionMenu } from "./SuggestionMenu";

export function NewChat({
  tenantId,
  onSubmit,
  onAbort,
  isSending,
  isAborting,
  onAttachmentsUploaded,
  onAttachmentRemoved,
  allowMutations = false,
  onAllowMutationsChange,
  hasScoutProAccess = true,
}: {
  tenantId?: string;
  onSubmit: ScoutSubmitHandler;
  onAbort: () => void;
  isSending: boolean;
  isAborting: boolean;
  onAttachmentsUploaded?: (attachments: ScoutAttachment[]) => void;
  onAttachmentRemoved?: (privateDocumentId: string) => void | Promise<void>;
  allowMutations?: boolean;
  onAllowMutationsChange?: (next: boolean) => void;
  hasScoutProAccess?: boolean;
}) {
  return (
    <ScoutChatDropzone
      sx={{
        flex: 1,
        width: "100%",
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Stack
        sx={{
          flex: 1,
          width: "100%",
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: 2,
          paddingTop: { xs: 8, sm: 9 },
          paddingBottom: { xs: 10, sm: 12 },
          transform: "translateY(calc(-2vh - 100px))",
          gap: 5,
        }}
      >
        <ScoutIcon sx={{ width: 80, height: 80 }} />
        <Typography variant="h6" textAlign="center">
          Hey there! I'm Scout, your Encamp guide. How can I help you today?
        </Typography>

        <ScoutInput
          tenantId={tenantId}
          conversationId={undefined}
          onSubmit={onSubmit}
          onAbort={onAbort}
          isSending={isSending}
          isAborting={isAborting}
          onAttachmentsUploaded={onAttachmentsUploaded}
          onAttachmentRemoved={onAttachmentRemoved}
          placeholder="Check regulations, help me understand compliance requirements..."
          compactPlaceholder="Ask Scout a question…"
          allowMutations={allowMutations}
          onAllowMutationsChange={onAllowMutationsChange}
          hasScoutProAccess={hasScoutProAccess}
        />

        <SuggestionMenu onPick={(prompt) => onSubmit(prompt)} disabled={isSending} />
      </Stack>
    </ScoutChatDropzone>
  );
}
